import { Button } from '@material-ui/core';
import { Fragment, useState, memo } from 'react';
import { CSSProperties } from 'styled-components';

import { UnitNotesDialog } from '~components/Alarms/UnitInfoDialog';

import { UnitContactsInfoDialog } from './UnitInfoDialog/UnitContactsInfoDialog';

import { Alarm, UnitType } from '~models';
import { boundActions } from '~store';

interface UnitsInfoButtonProps {
  unitType: UnitType;
  unitId: number;
  businessUnitId: number;
  title: string;
  backTo?: string;
  alarm?: Alarm;
  buttonStyle?: CSSProperties;
}

export const UnitsInfoButton = memo(
  ({ unitType, alarm, unitId, businessUnitId, title, backTo, buttonStyle }: UnitsInfoButtonProps) => {
    const [open, setOpen] = useState(false);

    return (
      <Fragment>
        <Button variant="outlined" color="primary" size="small" style={buttonStyle} onClick={() => setOpen(true)}>
          {title}
        </Button>

        {title === 'Notes' ? (
          <UnitNotesDialog
            open={open}
            backTo={backTo}
            unit={{ unitType, unitId, businessUnitId }}
            onClose={() => setOpen(false)}
          />
        ) : (
          <UnitContactsInfoDialog
            alarm={alarm as Alarm}
            open={open}
            backTo={backTo}
            unit={{ unitType, unitId, businessUnitId }}
            onClose={() => {
              setOpen(false);
              boundActions.alarms.resetUnitDetails();
            }}
          />
        )}
      </Fragment>
    );
  }
);
